export const REPORTING_LEGACY_OPERATOR_USAGE = 'reporting-legacy-operator-usage';